// vanilla/pages/photos.tsx
import React from "react";
import { Scroll } from "../components/scroll/scroll";
import { Header } from "../components/header/header";
import { useI18n } from "../i18n";
import { PhotoGrid } from "../components/gallery/photo-grid";
import { Footer } from "../components/footer/footer";
import photoFactory from "../data/unsplash-images";

const SUFFIX = "?w=512&auto=format&fit=crop&q=80&ixlib=rb-4.1.0";

const RAW_PHOTOS = photoFactory();

const formattedPhotos = RAW_PHOTOS.map((url, index) => ({
  id: `static-${index}`,
  src_thumb: `${url}${SUFFIX}`,
  src_full: `${url}${SUFFIX}`,
  alt: `Photo ${index + 1}`,
}));

export default function Photos() {
  const { translations } = useI18n();

  return (
    <Scroll>
      <main className="page">
        <Header
          title={translations.photos.title}
          breadcrumbs={[
            { label: "GAraujo", href: "/" },
            { label: translations.nav.photos, href: "/photos" },
          ]}
          description={translations.photos.descrition}
        />
        <div className="content photos-content">
          {formattedPhotos.length > 0 ? (
            <PhotoGrid photos={formattedPhotos} />
          ) : (
            <div className="no-images-state">Nenhuma imagem encontrada.</div>
          )}
        </div>
        <Footer />
      </main>
    </Scroll>
  );
}
